var input_selector = 'input[type=text], input[type=password], input[type=email], input[type=url], input[type=tel], input[type=number], input[type=search], textarea';
function updateTextFields() {
	$(input_selector).each(function (index, element) {
		var $this = $(this);
		var inputId = $this.attr('id');
		if ($(element).val().length > 0 || $(element).is(':focus') || element.autofocus) {
            $('label[for="'+ inputId +'"]').addClass('active');
            $('#'+ inputId).addClass('valid');
		} else if ($(element)[0].validity) {
			$('label[for="'+ inputId +'"]').toggleClass('active', $(element)[0].validity.badInput === true);
		} else {
            $('label[for="'+ inputId +'"]').removeClass('active');
		}
		if ($(element).is(':focus')) {
			$('label[for="'+ inputId +'"]').addClass('focusing');
		} else {
			$('label[for="'+ inputId +'"]').removeClass('focusing');
		}
	});
};
$(document).ready(function () {
    // Text based inputs
    var input_selector = 'input[type=text], input[type=password], input[type=email], input[type=url], input[type=tel], input[type=number], input[type=search], textarea';

    // Add active if form auto complete
    $(document).on('change', input_selector, function () {
        var inputId = $(this).attr('id');
        if ($(this).val().length !== 0 || $(this).attr('placeholder') !== undefined) {
            $('label[for="'+ inputId +'"]').addClass('active');
        }
    });

    var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
    var isSafari = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);
    if (isChrome || isSafari) {
        jQuery(document).ready(function() {
            setTimeout(function() {
                if($('input:-webkit-autofill')) {
                    $('input:-webkit-autofill').each(function(){
                        if ($(this).val().length !== "") {
                            var inputId = $(this).attr('id');
                            $('label[for="'+ inputId +'"]').addClass('active');
                        }
                    });
                }
            }, 200);
        });
    }
    // HTML DOM FORM RESET handling
    $(document).on('reset', function (e) {
        var formReset = $(e.target);
        if (formReset.is('form')) {
            formReset.find(input_selector).removeClass('valid').removeClass('invalid');
            formReset.find(input_selector).each(function () {
                var inputId = $(this).attr('id');
                if ($(this).attr('value') === '') {
                    $('label[for="'+ inputId +'"]').removeClass('active');
                }
            });
            // Reset select
            formReset.find('select.initialized').each(function () {
                var reset_text = formReset.find('option[selected]').text();
                formReset.siblings('input.select-dropdown').val(reset_text);
            });
        }
    });

    // Add active when element has focus
    $(document).on('focus change keyup', input_selector, function () {
        var inputId = $(this).attr('id');
        $('label[for="'+ inputId +'"]').addClass('active');
        $('label[for="'+ inputId +'"]').addClass('focusing');
        $(this).siblings('.prefix').addClass('active');
    });

    $(document).on('blur change keyup', input_selector, function () {
        var $inputElement = $(this);
        var selector = ".prefix";
        var inputId = $(this).attr('id');
        if ($inputElement.val().length === 0 && $inputElement[0].validity.badInput !== true ) {
            $('label[for="'+ inputId +'"]').removeClass('active');
            $('#' + inputId).removeClass('valid');
        }
		$('label[for="'+ inputId +'"]').removeClass('focusing');
		$inputElement.siblings(selector).removeClass('active');
	});

    updateTextFields();

    // Accordition footer
    if ($(window).width() < 767) {
        $('.site-footer__content .site-footer__item:not(.block-newsletter) .footer-title').click(function(){
            if($(this).hasClass('active')){
                $(this).removeClass('active');
                $(this).next('ul').slideUp();
            }else{
                $('.site-footer__content .site-footer__item:not(.block-newsletter) .footer-title').removeClass('active');
                $(this).addClass('active');
                $('.site-footer__item .site-footer__linklist').slideUp();
                $(this).next('ul').slideDown();
            }
        });
    }

    // Announcement
    if($('.announcement-bar .topbar-list').length  > 0){
        $('.announcement-bar .topbar-list').owlCarousel({
            dots: false,
            mouseDrag: false,
            navText: ['<i class="far fa-chevron-left"></i>','<i class="far fa-chevron-right"></i>'],
            responsive:{
                0:{
                    items: 1,
                    nav: true
                },
                900:{
                    items: 3,
                    mouseDrag: false
                }
            }
        })
    }
    if($('.search-suggest .ss-menu').length  > 0){
        $('.search-suggest .ss-menu').owlCarousel({
            dots: false,
            autoWidth: true,
            margin: 8,
            loop: true,
            autoPlay: true
        })
    }

    // Dropdown account
    $('#user-header').click(function(){
        $(this).closest('.account-box').toggleClass('active');
        $('body').toggleClass('open-minicart');
    })
    $(document).on("click", function(e){
        var container = $('#user-header+.user-info');
        var userIcon = $('#user-header');
        if(!container.is(e.target)
        && container.has(e.target).length === 0
        && userIcon.closest('.account-box').hasClass('active')
        && !userIcon.is(e.target)
        && userIcon.has(e.target).length === 0){
            userIcon.closest('.account-box').toggleClass('active');
            $('body').toggleClass('open-minicart');
        }
    });

    // Sidebar menu mobile
    $('.sidebar-selected').click(function(){
        $(this).toggleClass('active');
    })

    $(document).on('click', '.btn-close-message', function(){
        $(this).closest('.form-message, .spr-form-message, .input-error-message').hide();
    })

    // close geoIP popup
    jQuery('.geo-close').click(function(){
        $(this).closest('#GeoIp').removeClass('active');
        Cookies.set('geoip-popup', 1, { expires: 1, path: '/' });
    });
    jQuery('.geo-stay').click(function(e){
        $(this).closest('#GeoIp').removeClass('active');
        Cookies.set('geoip-popup', 1, { expires: 1, path: '/' });
    });


    // close Newsletter popup
    jQuery('.newsletter-close').click(function(){
        $(this).closest('#News-Popup').removeClass('active');
        Cookies.set('newsletter-popup', 1, { expires: 1, path: '/' });
    });

    jQuery('.newsletter__submit').click(function(){
        Cookies.set('newsletter-popup', 1, { expires: 1, path: '/' });
    });

    /// Hide Reviews
    setTimeout(function(){ 
        //console.log('123');
        var $elementData = $('.product-info .spr-badge');
        $elementData.each(function () {
            data = $(this).data("rating");
            if(data == "0.0" ){
                $(this).addClass('hide'); 
            }
        });
    }, 5000);

    $("input[type='number'], .number-fomat").on("keypress keyup blur",function (event) {    
        $(this).val($(this).val().replace(/[^\d].+/, ""));
         if ((event.which < 48 || event.which > 57)) {
             event.preventDefault();
         }
     });

    setTimeout(function () {
        jQuery('.use-brands .multiple-banner-item .owl-carousel').owlCarousel({
            dots: false,
            margin: 20,
            nav: true,
            autoWidth: true,
            loop: true,
            responsive:{
                0:{
                    margin: 20,
                },
                768:{
                    margin: 20,
                },
                1000:{
                    margin: 50,
                }
            },
            navText : [
                        '<i class="fas fa-chevron-left"></i>',
                        '<i class="fas fa-chevron-right"></i>'
                      ]
        });
        jQuery('.use-character-theme .multiple-banner-item .owl-carousel').owlCarousel({
            dots: false,
            margin: 20,
            nav: true,
            autoWidth: true,
            loop: true,
            responsive:{
                0:{
                    margin: 20,
                },
                768:{
                    margin: 20,
                },
                1000:{
                    margin: 50,
                }
            },
            navText : [
                        '<i class="fas fa-chevron-left"></i>',
                        '<i class="fas fa-chevron-right"></i>'
                      ]
        })
     }, 2000)

    setTimeout(function () {
    if($('body.template-product').length > 0){
        $('span.spr-badge-caption').on('click', function(){
            if(!$('#attributereview').closest('.accordian-tab').hasClass('open')){
                $('.accordian-tab').removeClass('open');
                $('.accordian-tab .tab-content').slideUp();
                $('#attributereview').closest('.accordian-tab').addClass('open');
                $('#attributereview').slideDown();
            }
        });
    }
    }, 3000)

    // toggle product partipating stores option
    $('.option.offer-only').on('click', function(){
        if(!$('.partipating-stores-wrapper').hasClass('show') && !$('.popup-show').hasClass('active')){
            $('.popup-show').addClass('active');
            $('.partipating-stores-wrapper').toggleClass('show').show();
            $('body').addClass('open-popup');
        }
    });

    $('.partipating-stores-wrapper .close-btn').on('click', function(){
        $('.popup-show').removeClass('active');
        if($('.partipating-stores-wrapper').hasClass('show') && !$('.popup-show').hasClass('active')){
            $('.popup-show').removeClass('active');
            $('.partipating-stores-wrapper').toggleClass('show').hide();
            $('body').removeClass('open-popup');
        }
    });

});
//Show newsletter popup
function show_newsletter(){
    if(!Cookies.get('newsletter-popup')){
        $('#News-Popup').addClass('active');
    }
}
jQuery(window).on('load', ()=> {
    function use_geolocation(country_code) {
        // console.log(country_code)
        if (country_code == 'NZ' && !Cookies.get('geoip-popup')) {
            $('#GeoIp').addClass('active');
        } else {
            show_newsletter();
        }
    }
    const country_code_name = "theme_country_code";
    const country_code = localStorage.getItem(country_code_name);
    if(country_code){
        // console.log("Getting country code from localstorage");
        use_geolocation(country_code);
    }
    else{
        // console.log("Checking country code with IPStack");
        $.getJSON('https://api.ipstack.com/check?access_key=bb8a649428a82d99f098d054f9d90f2e', (data) => {
            // The service below was used for dev purposes as IPStack could not be used
            // $.getJSON('https://api.ipdata.co/?api-key=55c9778afbbeef72df51583dd14975772a4abc53b9a69659549fc447', function (data) {
            localStorage.setItem(country_code_name, data.country_code);
            use_geolocation(localStorage.getItem(country_code_name));
        });
    }

    $(".bulky__item").click((event) => {
        console.log('test-test');
        event.stopPropagation();
        $(".modal-bulky-item").addClass('modal--is-active');
        $("html").addClass('stop-scrolling');
    });
    
      // Close modal when clicking the close button
      $(".close_modal__bulky-item").click(() => {
        $(".modal-bulky-item").removeClass('modal--is-active');
        $("html").removeClass('stop-scrolling');
      });
    
      // Close modal if clicking outside modal content (but not inside)
      $(document).click((event) => {
        if (!$(event.target).closest('.modal-content.modal__wrapper, .bulky__item').length && $(".modal-bulky-item").hasClass('modal--is-active')) {
          $(".modal-bulky-item").removeClass('modal--is-active');
          $("html").removeClass('stop-scrolling');
        }
      });
});